// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    // Fonction pour gérer les événements
    const formInputLabelEventHandle = (e) => {
        const formInput = e.target;
        if (formInput.classList.contains('js-label')) {
            const formInputParent = formInput.closest('.form__item');

            if (e.type === 'focusin') {
                formInputParent.classList.add('form__item--active');
            }

            if (e.type === 'focusout' || e.type === 'input') {
                if (formInput.value === '') {
                    formInputParent.classList.remove('form__item--active');
                } else {
                    formInputParent.classList.add('form__item--active');
                }
            }
        }
    };

    // Ajouter les écouteurs d'événements en utilisant la délégation d'événements
    document.addEventListener('focusin', formInputLabelEventHandle);
    document.addEventListener('focusout', formInputLabelEventHandle);
    document.addEventListener('input', formInputLabelEventHandle);

    // Fonction pour vérifier les nouveaux éléments ajoutés au DOM
    const checkNewInputLabel = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1) { // Vérifie que le nœud est un élément
                        if (node.classList.contains('js-label')) {
                            const formInputParent = node.closest('.form__item');
                            if (node.value !== '') {
                                formInputParent.classList.add('form__item--active');
                            }
                        }

                        // Vérifie les descendants de l'élément ajouté
                        const descendants = node.querySelectorAll('.js-label');
                        for (const descendant of descendants) {
                            const formInputParent = descendant.closest('.form__item');
                            if (descendant.value !== '') {
                                formInputParent.classList.add('form__item--active');
                            }
                        }
                    }
                }
            }
        }
    };

    // Configurer le MutationObserver
    const observer = new MutationObserver(checkNewInputLabel);

    // Définir les options d'observation
    const config = { childList: true, subtree: true };

    // Commencer à observer le document pour les ajouts d'éléments
    observer.observe(document.body, config);
});